__turbopack_context__.v({
  "sub-menu": "sub-menu-module-scss-module__yGkMha__sub-menu",
  "sub-menu--expanded": "sub-menu-module-scss-module__yGkMha__sub-menu--expanded",
  "sub-menu__item": "sub-menu-module-scss-module__yGkMha__sub-menu__item",
  "sub-menu__item--active": "sub-menu-module-scss-module__yGkMha__sub-menu__item--active",
});
